import { render } from "./FormQuiz.vue?vue&type=template&id=25ebef0c"
import script from "./FormQuiz.vue?vue&type=script&lang=js"
export * from "./FormQuiz.vue?vue&type=script&lang=js"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__